var _path, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.432326 2.09028C0.61498 1.75893 0.942122 1.56104 1.30743 1.56104H13.902C14.2673 1.56104 14.5944 1.7588 14.7771 2.09028C14.9597 2.42176 14.9597 2.81743 14.7771 3.14904L10.1439 11.5552V17.9711C10.1439 18.3785 9.92698 18.7426 9.57774 18.9219C9.43522 18.995 9.28313 19.0309 9.13179 19.0309C8.91256 19.0309 8.6954 18.9553 8.51374 18.8075L5.45613 16.3222C5.20387 16.1172 5.06518 15.8202 5.06518 15.4857L5.06505 11.555L0.431859 3.14892C0.249573 2.8177 0.249549 2.42176 0.432326 2.09028ZM5.97274 11.0172C6.06382 11.1824 6.10814 11.3556 6.10814 11.5464V15.4695L9.10193 17.9031L9.1018 11.5461C9.1018 11.3551 9.14612 11.182 9.2372 11.0168L13.8471 2.65284H1.36259L5.97274 11.0172ZM8.80781 15.8195V11.8605C8.80781 11.5591 8.57434 11.3145 8.28661 11.3145C7.99888 11.3145 7.7654 11.5591 7.7654 11.8605V15.8195C7.7654 16.1209 7.99888 16.3655 8.28661 16.3655C8.57446 16.3655 8.80781 16.1209 8.80781 15.8195Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3898,
    cy: 3.1989,
    rx: 2.61051,
    ry: 2.72967,
    fill: "url(#paint0_linear_3520_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3520_94",
    x1: 11.7793,
    y1: 3.1989,
    x2: 17.0003,
    y2: 3.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9F20"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e7098478a7208b21a0b1a73ed2a67042.svg";
export { ForwardRef as ReactComponent };